// extracted by mini-css-extract-plugin
export default {"list":"SupportContent_list__eajfF","checkList":"SupportContent_checkList__1bKWe"};